module.exports = __webpack_public_path__ + "static/media/6530.6861fee1.jpg";